(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[363],{

/***/ 19448:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "VF": function() { return /* binding */ AlertModal; },
  "Cv": function() { return /* binding */ ErrorModal; },
  "i_": function() { return /* binding */ SuccessModal; }
});

// UNUSED EXPORTS: ModalDialogContentText

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(26297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Button/Button.js + 3 modules
var Button = __webpack_require__(26993);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Dialog/Dialog.js + 1 modules
var Dialog = __webpack_require__(1890);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Link/Link.js + 2 modules
var Link = __webpack_require__(68346);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/config/environment.ts
var environment = __webpack_require__(60031);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Check.js
var Check = __webpack_require__(27036);
;// CONCATENATED MODULE: ./src/components/icons/CheckIcon.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #00a650;\n  height: 19px;\n  width: 19px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  border: 1px solid #00a650;\n  border-radius: 100px;\n  width: 32px;\n  height: 32px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var CheckIconStyled = (0,styled/* default */.Z)(Check/* default */.Z)(_templateObject());
var CheckCircleDiv = (0,styled/* default */.Z)("div")(_templateObject1());
var CheckIcon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCircleDiv, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckIconStyled, {})
    });
};

;// CONCATENATED MODULE: ./src/components/icons/WarningIcon.tsx



var WarningIconContainer = (0,styled/* default */.Z)("div")(function(param) {
    var width = param.width, height = param.height;
    return {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: width,
        height: height
    };
});
var WarningIcon = function(param) {
    var _width = param.width, width = _width === void 0 ? 40 : _width, _height = param.height, height = _height === void 0 ? 32 : _height;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(WarningIconContainer, {
        width: width,
        height: height,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            src: "/assets/images/warningIcon.png",
            alt: "Warning icon",
            width: width,
            height: height
        })
    });
};

;// CONCATENATED MODULE: ./src/components/icons/index.ts



;// CONCATENATED MODULE: ./src/components/Modal.tsx












var IconContainer = (0,styled/* default */.Z)("div")({
    position: "relative",
    height: "14px",
    width: "14px",
    marginLeft: "90%",
    marginTop: "20px"
});
var Container = (0,styled/* default */.Z)("div")({});
var DialogTitle = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "17px",
    lineHeight: "150%",
    letterSpacing: "0.15px",
    color: "#414046",
    textAlign: "center",
    padding: "18px"
});
var DialogContentText = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "150%",
    letterSpacing: "-0.011em",
    textAlign: "center",
    color: "#414046",
    padding: "0px 18px 12px 18px"
});
var IconContainerWrapper = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    justifyItems: "center",
    padding: "0px 18px"
});
var DialogActions = (0,styled/* default */.Z)("div", {
    shouldForwardProp: function(prop) {
        return prop !== "direction";
    }
})(function(param) {
    var direction = param.direction;
    return {
        display: "flex",
        flexDirection: direction || "column",
        alignItems: "center",
        padding: direction === "row" ? "16px" : "17px 0px",
        gap: direction === "row" ? "16px" : "0px"
    };
});
var ButtonAction = (0,styled/* default */.Z)(Button/* default */.Z)({
    borderRadius: "100px",
    height: "42px",
    width: "199px",
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0.15px",
    textDecoration: "none",
    textTransform: "none"
});
var Pointer = (0,styled/* default */.Z)("div")({
    cursor: "pointer"
});
var ModalDialog = (0,styled/* default */.Z)(Dialog/* default */.Z, {
    shouldForwardProp: function(prop) {
        return prop !== "changeDialogPaper";
    }
})(function(param) {
    var changeDialogPaper = param.changeDialogPaper;
    return {
        "& .MuiDialog-paper": (0,_object_spread/* default */.Z)({
            margin: 16,
            maxWidth: 336,
            borderRadius: "10px"
        }, changeDialogPaper ? {
            width: "100%",
            minHeight: 197
        } : {})
    };
});
var ModalDialogContentText = (0,styled/* default */.Z)(DialogContentText, {
    shouldForwardProp: function(prop) {
        return prop !== "alingContentLeft";
    }
})(function(param) {
    var alignContentLeft = param.alignContentLeft;
    return {
        textAlign: alignContentLeft ? "left" : "center",
        whiteSpace: "pre-line"
    };
});
function AlertModal(props) {
    var title = props.title, open = props.open, content = props.content, children = props.children, actions = props.actions, actionsDirection = props.actionsDirection, setOpen = props.setOpen, onClose = props.onClose, disableEscapeKeyDown = props.disableEscapeKeyDown, onBackdropClick = props.onBackdropClick, AlignContentLeft = props.AlignContentLeft, changeDialogPaper = props.changeDialogPaper, icon = props.icon, otherProps = (0,_object_without_properties/* default */.Z)(props, [
        "title",
        "open",
        "content",
        "children",
        "actions",
        "actionsDirection",
        "setOpen",
        "onClose",
        "disableEscapeKeyDown",
        "onBackdropClick",
        "AlignContentLeft",
        "changeDialogPaper",
        "icon"
    ]);
    var handleClose = function() {
        if (onClose) onClose();
        else if (actions.length === 1) actions[0].onActionClick();
        setOpen(false);
    };
    var haveHandleClose = (actions === null || actions === void 0 ? void 0 : actions.length) === 1 || onClose;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalDialog, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
        open: open,
        onClose: handleClose,
        changeDialogPaper: changeDialogPaper,
        disableEscapeKeyDown: disableEscapeKeyDown,
        onBackdropClick: onBackdropClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
                    children: haveHandleClose && /*#__PURE__*/ (0,jsx_runtime.jsx)(Pointer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            layout: "fill",
                            src: "/assets/images/home/closeicon.webp",
                            alt: "closeIcon",
                            objectFit: "contain",
                            onClick: handleClose
                        })
                    })
                }),
                icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainerWrapper, {
                    children: icon
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogTitle, {
                    children: title
                }),
                content && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalDialogContentText, {
                    alignContentLeft: AlignContentLeft,
                    children: content
                }),
                children,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogActions, {
                    direction: actionsDirection,
                    children: actions === null || actions === void 0 ? void 0 : actions.map(function(action, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonAction, {
                            onClick: action.onActionClick,
                            color: "primary",
                            variant: action.variant,
                            children: action.text
                        }, index);
                    })
                })
            ]
        })
    }));
}
function ErrorModal(props) {
    var open = props.open, title = props.title, description = props.description, handleBack = props.handleBack, whatsappText = props.whatsappText;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertModal, {
        title: title,
        open: open,
        setOpen: function() {},
        disableEscapeKeyDown: true,
        disableBackdropClick: true,
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(WarningIcon, {}),
        actions: [
            {
                text: "Aceptar",
                onActionClick: handleBack,
                variant: "contained"
            }, 
        ],
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalDialogContentText, {
            children: [
                description,
                ", intenta nuevamente o",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    target: "_blank",
                    href: "https://api.whatsapp.com/send?phone=".concat(environment/* PHONE_NUMBER.CLEAN */.UE.CLEAN, "&text=").concat(encodeURI(whatsappText)),
                    children: "cont\xe1ctanos para recibir ayuda"
                })
            ]
        })
    });
}
function SuccessModal(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AlertModal, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckIcon, {})
    }));
}


/***/ }),

/***/ 84768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ useChatwoot; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45680);
/* harmony import */ var _hooks_useAuth__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75625);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36023);
/* harmony import */ var crypto_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(crypto_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _config_environment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60031);
/* harmony import */ var _services_firebase__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45997);
// src/hooks/useChatwoot.ts







var useChatwoot = function(param) {
    var enabled = param.enabled;
    var appUser = (0,_hooks_useAuth__WEBPACK_IMPORTED_MODULE_0__/* .useAuth */ .a)().appUser;
    var currentUser = (0,_services_firebase__WEBPACK_IMPORTED_MODULE_4__/* .getFirebaseAuth */ .yL)().currentUser;
    var authToken = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
        var _tmp;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!currentUser) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        currentUser.getIdToken()
                    ];
                case 1:
                    _tmp = _state.sent();
                    return [
                        3,
                        3
                    ];
                case 2:
                    _tmp = "";
                    _state.label = 3;
                case 3:
                    return [
                        2,
                        _tmp
                    ];
            }
        });
    }), []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var scriptId = "chatwoot-script";
        if (!enabled) {
            var existingScript = document.getElementById(scriptId);
            if (existingScript) {
                existingScript.remove();
            }
            document.querySelectorAll(".woot-widget-holder, .woot-widget-bubble").forEach(function(el) {
                return el.remove();
            });
            return;
        }
        if (document.getElementById(scriptId)) return;
        window.chatwootSettings = {
            position: "right",
            type: "standard",
            launcherTitle: "\xbfNecesitas ayuda?",
            showPopoutButton: true,
            hideMessageBubble: false,
            locale: "es",
            language: "es"
        };
        var g = document.createElement("script");
        g.id = scriptId;
        g.src = "".concat(_config_environment__WEBPACK_IMPORTED_MODULE_3__/* .CHATWOOT_BASE_URL */ .W0, "/packs/js/sdk.js");
        g.defer = true;
        g.async = true;
        document.body.appendChild(g);
        g.onload = function() {
            var ref;
            (ref = window.chatwootSDK) === null || ref === void 0 ? void 0 : ref.run({
                websiteToken: _config_environment__WEBPACK_IMPORTED_MODULE_3__/* .CHATWOOT_WEBSITE_TOKEN */ .kq,
                baseUrl: _config_environment__WEBPACK_IMPORTED_MODULE_3__/* .CHATWOOT_BASE_URL */ .W0
            });
        };
    }, [
        enabled
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!enabled || !appUser) return;
        var interval = setInterval(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
            var idHash, token;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!window.$chatwoot) return [
                            3,
                            2
                        ];
                        idHash = crypto_js__WEBPACK_IMPORTED_MODULE_2___default().HmacSHA256(appUser.id.toString(), _config_environment__WEBPACK_IMPORTED_MODULE_3__/* .CHATWOOT_SECRET */ .$K).toString((crypto_js__WEBPACK_IMPORTED_MODULE_2___default().enc.Hex));
                        window.$chatwoot.setUser(appUser.id.toString(), {
                            email: appUser.email,
                            name: appUser.name,
                            phone_number: appUser.phone,
                            identifier_hash: idHash
                        });
                        return [
                            4,
                            authToken()
                        ];
                    case 1:
                        token = _state.sent();
                        window.$chatwoot.setCustomAttributes({
                            auth_token: token ? "Bearer ".concat(token) : null
                        });
                        clearInterval(interval);
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        }), 500);
        return function() {
            return clearInterval(interval);
        };
    }, [
        enabled,
        appUser
    ]);
};


/***/ }),

/***/ 78459:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ AssistantButton; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(45680);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Fab/Fab.js + 1 modules
var Fab = __webpack_require__(10160);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Add.js
var Add = __webpack_require__(96540);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(50319);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/graphql-tag/lib/index.js + 9 modules
var lib = __webpack_require__(57800);
;// CONCATENATED MODULE: ./src/queries/order/mutations/createOrder.tsx
/*
 * File: createOrder.tsx
 * Project: meki
 * File Created: Wednesday, 4th November 2020 11:08:37 am
 * Author: Vicente Melin (vicente@inventures.cl)
 * -----
 * Last Modified: Thursday, 29th April 2021 12:46:47 pm
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2019 - 2020 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 
function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation ",
        " {\n    createOrder {\n      id\n      uuid\n      orderDetails {\n        id\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var CreateOrderMutation = function(name) {
    return (0,lib/* gql */.Ps)(_templateObject(), name);
};

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/toast.hook.tsx + 4 modules
var toast_hook = __webpack_require__(11263);
// EXTERNAL MODULE: ./src/components/Modal.tsx + 3 modules
var Modal = __webpack_require__(19448);
// EXTERNAL MODULE: ./src/utils/index.ts + 3 modules
var utils = __webpack_require__(8881);
// EXTERNAL MODULE: ./src/hooks/usePermissions.tsx + 1 modules
var usePermissions = __webpack_require__(18782);
// EXTERNAL MODULE: ./src/hooks/useOrderState.tsx
var useOrderState = __webpack_require__(778);
// EXTERNAL MODULE: ./src/hooks/useMekiState.tsx + 1 modules
var useMekiState = __webpack_require__(48231);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/screens/home/components/AssistantButton.tsx
/*
 * File: AssistantButton.tsx
 * Project: meki
 * File Created: Wednesday, 29th December 2021 4:39:13 pm
 * Author: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Last Modified: Thursday, 24th November 2022 4:10:32 pm
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2019 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 
















var FloatingAssistantButton = dynamic_default()(function() {
    var promise = Promise.all(/* import() */[__webpack_require__.e(1826), __webpack_require__.e(1543), __webpack_require__.e(2760), __webpack_require__.e(4645)]).then(__webpack_require__.bind(__webpack_require__, 4645)).then(function(mod) {
        return mod.FloatingAssistantButton;
    });
    return promise;
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4645)
            ];
        }
    },
    ssr: false,
    loading: function() {
        return null;
    }
});
var AssistantCreateNewOrderFab = (0,styled/* default */.Z)(Fab/* default */.Z)({
    position: "fixed",
    right: 15,
    bottom: 70
});
function AssistantButton() {
    var userCan = (0,usePermissions/* usePermissions */.T)().userCan;
    var toasts = (0,toast_hook/* useToast */.p)();
    // App state
    var setOrderUuid = (0,useOrderState/* useOrderState */.h)().setOrderUuid;
    var setUserEmail = (0,useMekiState/* useMekiState */.c)().setUserEmail;
    // Local state
    var ref = (0,react.useState)(false), newOrderModal = ref[0], setNewOrderModal = ref[1];
    // Other vars
    var isAssistant = userCan("MANAGE_USER");
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(CreateOrderMutation("assistantCreateOrderHome")), 2), mutate = ref1[0], loading = ref1[1].loading;
    if (!isAssistant) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FloatingAssistantButton, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AssistantCreateNewOrderFab, {
                color: "primary",
                variant: "extended",
                onClick: function() {
                    return setNewOrderModal(true);
                },
                disabled: loading,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Add/* default */.Z, {}),
                    "Cotizaci\xf3n"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* AlertModal */.VF, {
                title: "Nueva cotizaci\xf3n ⚠️",
                content: "Se crear\xe1 una nueva cotizaci\xf3n vacia y no podr\xe1s acceder a la anterior",
                open: newOrderModal,
                setOpen: setNewOrderModal,
                onClose: function() {
                    return setNewOrderModal(false);
                },
                actions: [
                    {
                        text: "CANCELAR",
                        onActionClick: function() {
                            return setNewOrderModal(false);
                        }
                    },
                    {
                        text: "confirmar",
                        onActionClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                            var ref, _data, order;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        setNewOrderModal(false);
                                        setUserEmail("");
                                        return [
                                            4,
                                            mutate()
                                        ];
                                    case 1:
                                        ref = _state.sent(), _data = ref.data, order = _data.createOrder;
                                        utils/* Console.log */.Mn.log({
                                            msg: "[Home] change order uuid",
                                            orderUuid: order.uuid
                                        });
                                        setOrderUuid(order.uuid);
                                        toasts.showToast({
                                            message: "Inicio de nueva cotizaci\xf3n",
                                            type: "success"
                                        });
                                        return [
                                            2
                                        ];
                                }
                            });
                        }),
                        variant: "contained"
                    }, 
                ]
            })
        ]
    });
}


/***/ }),

/***/ 58503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CV": function() { return /* binding */ HeaderAppBar; },
/* harmony export */   "Fe": function() { return /* binding */ HeaderToolbar; },
/* harmony export */   "NI": function() { return /* binding */ HeaderLeftDiv; },
/* harmony export */   "TX": function() { return /* binding */ LoginButton; },
/* harmony export */   "ZO": function() { return /* binding */ PositionDivLeft; },
/* harmony export */   "mx": function() { return /* binding */ PositionDivRight; },
/* harmony export */   "of": function() { return /* binding */ RootDiv; },
/* harmony export */   "tb": function() { return /* binding */ HeaderRightComponent; },
/* harmony export */   "vj": function() { return /* binding */ MekiLogoDiv; }
/* harmony export */ });
/* unused harmony export BackIconButton */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47842);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13264);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85050);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20784);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80562);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26993);
/*
 * File: homeNavBa
 * Project: meki
 * File Created: Thursday, 28th July 2022 4:01:26 pm
 * Author: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Last Modified: Wednesday, 18th January 2023 12:23:58 pm
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2019 - 2022 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 


var RootDiv = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    flexGrow: 1,
    "& .MuiButton-root": {
        textTransform: "None"
    },
    position: "sticky",
    top: 0,
    zIndex: 1100
});
var HeaderAppBar = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(param) {
    var theme = param.theme, elevation = param.elevation;
    return {
        top: 0,
        bottom: "auto",
        height: 64,
        background: theme.palette.common.white,
        boxShadow: elevation ? "0px 1px 10px rgb(0 0 0 / 12%)" : "none",
        transition: "background-color 0.4s",
        backdropFilter: "blur(5px)",
        "@media (min-width: 800px)": {
            height: "inherit"
        },
        position: "relative"
    };
});
var HeaderToolbar = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    justifyContent: "space-between",
    minHeight: 64,
    backgroundColor: "transparent",
    paddingRight: 0,
    paddingLeft: "12px"
});
var PositionDivLeft = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")(function(param) {
    var theme = param.theme;
    return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        flex: 0,
        position: "absolute",
        left: 20,
        zIndex: 1
    }, theme.breakpoints.down("md"), {
        zIndex: 0,
        left: 0,
        position: "unset"
    });
});
var PositionDivRight = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")(function(param) {
    var theme = param.theme;
    return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        flex: 0,
        position: "absolute",
        right: 12,
        zIndex: 1
    }, theme.breakpoints.down("md"), {
        zIndex: 3000,
        right: 0,
        position: "unset"
    });
});
var HeaderLeftDiv = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    zIndex: 0,
    display: "flex",
    alignItems: "center"
});
var BackIconButton = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
    return {
        color: "#004C8C"
    };
});
var HeaderRightComponent = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    display: "flex",
    alignItems: "center"
});
var MekiLogoDiv = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    cursor: "pointer",
    marginLeft: 9,
    display: "flex"
});
var LoginButton = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function() {
    return {
        color: "#414046",
        borderColor: "#414046",
        height: 19,
        fontFamily: "Poppins",
        fontStyle: "normal",
        fontWeight: 600,
        fontSize: "16px",
        lineHeight: "24px",
        letterSpacing: "1px",
        maxWidth: 180,
        textDecoration: "underline",
        "@media (max-width: 767px)": {
            fontSize: 12
        }
    };
});



/***/ }),

/***/ 84295:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ HomeNavBar; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(70865);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _homeNavBar_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58503);
/* harmony import */ var _screens_menu__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85393);
/* harmony import */ var _components_icons_LogoMeki__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73604);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8881);
/* harmony import */ var _hooks_useAuth__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(75625);
/* harmony import */ var _hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(71096);
/* harmony import */ var _screens_cart_DrawerCart__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(24950);
/* harmony import */ var _hooks_useFocusSearchBox__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(31515);
/* harmony import */ var _components_searchBox__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(82653);
/* harmony import */ var _validators_Events_Interactions__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(40813);
/* harmony import */ var _hooks_useEventTracking__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(66630);















function HomeNavBar(param) {
    var isVisible = param.isVisible, setIsVisible = param.setIsVisible;
    var ref, ref1, ref2;
    var ref3 = (0,_hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_8__/* .useWindowSize */ .i)(), width = ref3.width, isDesktop = ref3.isDesktop;
    var track = (0,_hooks_useEventTracking__WEBPACK_IMPORTED_MODULE_13__/* .useEventTracking */ .A)().track;
    var ref4 = (0,_hooks_useAuth__WEBPACK_IMPORTED_MODULE_7__/* .useAuth */ .a)(), user = ref4.appUser;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var focusSearchBox = (0,_hooks_useFocusSearchBox__WEBPACK_IMPORTED_MODULE_10__/* .useFocusSearchBox */ .G)();
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), hideInfo = ref5[0], setHideInfo = ref5[1];
    var elevation = 1;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (isVisible && !isDesktop) {
            setHideInfo(true);
            return;
        }
        setHideInfo(false);
    }, [
        focusSearchBox,
        isVisible,
        isDesktop
    ]);
    var ref6;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_homeNavBar_styles__WEBPACK_IMPORTED_MODULE_2__/* .RootDiv */ .of, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_homeNavBar_styles__WEBPACK_IMPORTED_MODULE_2__/* .HeaderAppBar */ .CV, {
            color: "primary",
            elevation: elevation,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_homeNavBar_styles__WEBPACK_IMPORTED_MODULE_2__/* .HeaderToolbar */ .Fe, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_homeNavBar_styles__WEBPACK_IMPORTED_MODULE_2__/* .PositionDivLeft */ .ZO, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_homeNavBar_styles__WEBPACK_IMPORTED_MODULE_2__/* .HeaderLeftDiv */ .NI, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_screens_menu__WEBPACK_IMPORTED_MODULE_3__/* .DrawerMenu */ .O, {}),
                                !hideInfo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_homeNavBar_styles__WEBPACK_IMPORTED_MODULE_2__/* .MekiLogoDiv */ .vj, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icons_LogoMeki__WEBPACK_IMPORTED_MODULE_4__/* .MekiLogo */ .$, {
                                        fill: "#414046",
                                        height: "24px",
                                        width: "auto",
                                        onClick: function() {
                                            void router.push((0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .getRoute */ .Bv)("home"));
                                        }
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_searchBox__WEBPACK_IMPORTED_MODULE_11__/* .SearchBox */ .R, {
                        isHeader: true,
                        isVisible: isVisible,
                        setIsVisible: setIsVisible
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_homeNavBar_styles__WEBPACK_IMPORTED_MODULE_2__/* .PositionDivRight */ .mx, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_homeNavBar_styles__WEBPACK_IMPORTED_MODULE_2__/* .HeaderRightComponent */ .tb, {
                            children: [
                                !hideInfo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: !user ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_homeNavBar_styles__WEBPACK_IMPORTED_MODULE_2__/* .LoginButton */ .TX, {
                                        size: "medium",
                                        onClick: function() {
                                            void track(_validators_Events_Interactions__WEBPACK_IMPORTED_MODULE_12__/* .InteractionEventTypes.ClickLogin */ .P.ClickLogin, {
                                                location: "navbar"
                                            });
                                            void router.push({
                                                pathname: "/ingresar",
                                                query: (0,_utils__WEBPACK_IMPORTED_MODULE_6__/* .removeUndefineds */ .ox)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, router.query))
                                            }, {
                                                pathname: "/ingresar"
                                            });
                                        },
                                        children: width >= 1110 ? "Iniciar sesi\xf3n" : "Inicia"
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_screens_menu__WEBPACK_IMPORTED_MODULE_3__/* .DrawerMenu */ .O, {
                                        isFromMenuName: "".concat((ref = user.name) === null || ref === void 0 ? void 0 : ref.split(" ")[0], " ").concat((ref6 = (ref1 = user.lastNames) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[0]) === null || ref2 === void 0 ? void 0 : ref2.toLocaleUpperCase()) !== null && ref6 !== void 0 ? ref6 : "", ".")
                                    })
                                }),
                                (isDesktop || !isDesktop && !focusSearchBox.isFocus) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_screens_cart_DrawerCart__WEBPACK_IMPORTED_MODULE_9__/* .DrawerCart */ .$, {})
                            ]
                        })
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 9762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "g": function() { return /* binding */ CategoriesCard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Card/Card.js + 1 modules
var Card = __webpack_require__(49837);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
;// CONCATENATED MODULE: ./src/screens/home/landing/HeroSection/style/categoryCard.style.tsx



var CategoriesCardContainer = (0,styled/* default */.Z)("div")(function(param) {
    var theme = param.theme, logIn = param.logIn;
    var _obj;
    return _obj = {
        zIndex: 10,
        display: "flex",
        flexDirection: "row",
        gap: 30,
        overflowX: "auto",
        padding: logIn ? "32px 4%" : 10,
        justifyContent: logIn ? "flex-start" : "center"
    }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down("md"), {
        padding: logIn ? "20px 20px" : "0px 20px",
        gap: 10,
        justifyContent: "left"
    }), (0,_define_property/* default */.Z)(_obj, "scrollbarWidth", "none"), (0,_define_property/* default */.Z)(_obj, "-ms-overflow-style", "none"), (0,_define_property/* default */.Z)(_obj, "&::-webkit-scrollbar", {
        display: "none"
    }), _obj;
});
var CategoryCardContainer = (0,styled/* default */.Z)(Card/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        backgroundColor: "#FFFFFF",
        width: 200,
        height: 176,
        padding: 10,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 8,
        borderRadius: 8,
        flex: "0 0 auto",
        cursor: "pointer",
        boxShadow: "0px 0px 12px rgba(0,0,0,0.3)",
        marginTop: "4px"
    }, theme.breakpoints.down("md"), {
        width: "148px",
        height: "140px",
        padding: 4
    });
});
var CategoryCardTitle = (0,styled/* default */.Z)(Typography/* default */.Z)(function(param) {
    var theme = param.theme;
    return (0,_define_property/* default */.Z)({
        fontSize: 18,
        fontWeight: 600,
        color: "#414046",
        textAlign: "center",
        fontFamily: "Poppins",
        whiteSpace: "pre-wrap",
        padding: "0px 10px"
    }, theme.breakpoints.down("md"), {
        fontSize: 14,
        maxWidth: 120
    });
});


// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/utils/index.ts + 3 modules
var utils = __webpack_require__(8881);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/screens/home/landing/HeroSection/categoriesCard.tsx






var categories = [
    {
        name: "Medicamentos",
        image: "/assets/images/newLanding/CategoriesMenu/Medicamentos.svg",
        slug: "medicamentos"
    },
    {
        name: "Cuidado personal",
        image: "/assets/images/newLanding/CategoriesMenu/CuidadoPersonal.svg",
        slug: "cuidado-personal"
    },
    {
        name: "Belleza",
        image: "/assets/images/newLanding/CategoriesMenu/Belleza.svg",
        slug: "belleza"
    },
    {
        name: "Vitaminas y suplementos",
        image: "/assets/images/newLanding/CategoriesMenu/VitySupl.svg",
        slug: "vitaminas-y-suplementos"
    },
    {
        name: "Mascotas",
        image: "/assets/images/newLanding/CategoriesMenu/Mascotas.svg",
        slug: "veterinaria"
    }, 
];
var CategoriesCard = function() {
    var router = (0,next_router.useRouter)();
    var currentLocation = (0,react.useMemo)(function() {
        return router.asPath.includes("inicio");
    }, [
        router.asPath
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoriesCardContainer, {
        logIn: currentLocation,
        children: categories.map(function(category) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryCardContainer, {
                onClick: function() {
                    void router.push((0,utils/* getRoute */.Bv)("subCategories", {
                        categorySlug: category.slug
                    }));
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: category.image,
                        alt: category.name,
                        width: 78,
                        height: 78
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryCardTitle, {
                        children: category.name
                    })
                ]
            }, category.name);
        })
    });
};


/***/ }),

/***/ 50633:
/***/ (function() {

/* (ignored) */

/***/ })

}]);